import { render, staticRenderFns } from "./account-header.vue?vue&type=template&id=1bbad21e&scoped=true&lang=pug&"
import script from "./account-header.vue?vue&type=script&lang=coffee&"
export * from "./account-header.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbad21e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default})
